import React from "react";
import { IoLogoGooglePlaystore } from 'react-icons/io5';
import { FaAppStoreIos } from 'react-icons/fa';
import { FaWindows } from 'react-icons/fa';
import { GameDetails, GameMeta } from "./types";
import { Link } from "react-router-dom";

export const imagePlayerDataArray: NodeRequire[] = [
	require('images/1.png'),
	require('images/2.png'),
	require('images/3.png'),
	require('images/4.png'),
	require('images/5.png'),
	require('images/6.png'),
];


const FPSDetails: GameDetails = {
	parallaxBanner: require('images//FPS/banner.png'),
	logo: require('images/FPS/logo.png'),
	carouselImages: [
		require('images/1.png'),
		require('images/2.png'),
		require('images/3.png'),
		require('images/4.png'),
		require('images/5.png'),
		require('images/6.png'),
	],
	gridImages: [
		require('images/1.png'),
		require('images/2.png'),
		require('images/3.png'),
		require('images/4.png'),
		require('images/5.png'),
		require('images/6.png'),
	],
	videos: [
		
	],
	playNowLinks: [
		{
			to: '',
			title: 'Playstore',
			target: '_blank',
		},
		{
			to: '',
			title: 'Appstore',
			target: '_blank',
		},
	],
};







const BlimpDetail: GameDetails = {
	parallaxBanner: require('images/3.png'),
	logo: require('images/Blimp/logo.png'),
	carouselImages: [
		require('images/1.png'),
		require('images/2.png'),
		require('images/3.png'),
		require('images/4.png'),
		require('images/5.png'),
		require('images/6.png'),
	],
	gridImages: [
		require('images/1.png'),
		require('images/2.png'),
		require('images/3.png'),
		require('images/4.png'),
		require('images/5.png'),
		require('images/6.png'),
	],
	videos: [
		{
			src: 'https://www.youtube.com/embed/8IH_Qr1WIhY?si=guKMIEizKCLXfWY0',
			caption:
				'Gameplay footage. Huge appreciation to Games Over Coffee Consulting Youtube channel for giving me insightful & valuable feedbacks!',
		},
		{
			src: 'https://www.youtube.com/embed/8IH_Qr1WIhY?si=guKMIEizKCLXfWY0',
			caption:
				'Gameplay footage. Huge appreciation to Games Over Coffee Consulting Youtube channel for giving me insightful & valuable feedbacks!',
		},
	],
	playNowLinks: [
		{
			to: '',
			title: 'Playstore',
			target: '_blank',
		},
		{
			to: '',
			title: 'Appstore',
			target: '_blank',
		},
	],
};






const ShotgubBirbDetails: GameDetails = {
	parallaxBanner: require('images/ShotgunBirb/banner.png'),
	logo: require('images/ShotgunBirb/logo.png'),
	carouselImages: [
		require('images/1.png'),
		require('images/2.png'),
		require('images/3.png'),
		require('images/4.png'),
		require('images/5.png'),
		require('images/6.png'),
	],
	gridImages: [
		require('images/1.png'),
		require('images/2.png'),
		require('images/3.png'),
		require('images/4.png'),
		require('images/5.png'),
		require('images/6.png'),
	],
	videos: [
		{
			src: 'https://www.youtube.com/embed/8IH_Qr1WIhY?si=guKMIEizKCLXfWY0',
			caption:
				'Gameplay footage. Huge appreciation to Games Over Coffee Consulting Youtube channel for giving me insightful & valuable feedbacks!',
		},
	],
	playNowLinks: [
		{
			to: '',
			title: 'Playstore',
			target: '_blank',
		},
		{
			to: '',
			title: 'Appstore',
			target: '_blank',
		},
	],
};















export const gameMetaArray: GameMeta[] = [
	{
		url: 'fps',
		title: 'FPS - Flight Physics Simulator',
		description: 'A flight simulator focussing on Aesthetic and Physics with multiple vehicles controls.',
		imgPath: require('images/FPS/thumbnail.png'),
		gameDetails: FPSDetails,
		platformIcons: [<IoLogoGooglePlaystore />, <FaAppStoreIos />],
	},
	{
		url: 'blimp',
		title: 'Blimp: Showdown',
		description:
			'2-4 player game designed for parties or family nights, where each player can craft their unique ship based on their play style.',
		imgPath: require('images/Blimp/thumbnail.png'),
		gameDetails: BlimpDetail,
		platformIcons: [],
	},
	{
		url: 'shogunbirb',
		title: 'Shotgun Birb',
		description:
			'2-4 player game designed for parties or family nights, where each player can craft their unique ship based on their play style.',
		imgPath: require('images/ShotgunBirb/thumbnail.png'),
		gameDetails: ShotgubBirbDetails,
		platformIcons: [],
	},
];


